
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as index_1yPZ9E4sXNQdvJ8urx3VX6hEo9s9Pej1Y1RhFdGfoEMeta } from "/app/pages/game/index.vue?macro=true";
import { default as indexZoRl0O3HdeL6tALF_45Ty2aq8nNG9odyaCcjqrf90NbtIMeta } from "/app/pages/game/clashlands/index.vue?macro=true";
import { default as clashlands0VGdx5S_45zgF8_45LGf03pwOXTNJnc7J_XVZkkVvpPCGHoMeta } from "/app/pages/game/clashlands.vue?macro=true";
import { default as guideAHnivJoLASjtXot4S5WKe93ON1voDHlsQVig3Gwt1qwMeta } from "/app/pages/game/dungeon-explorer/guide.vue?macro=true";
import { default as indexN5_RbRHSEF03_UoR64cFEh_45Z7qBb8pApFIHElC66_45g4Meta } from "/app/pages/game/dungeon-explorer/index.vue?macro=true";
import { default as leaderboarda544q4twEaRx9A1VOiX7FJxQC_hF7oZYxH9X5Sa2VAMMeta } from "/app/pages/game/dungeon-explorer/leaderboard.vue?macro=true";
import { default as dungeon_45explorerM2LXErIaib5qEqVvhP_45z_45wPoghMUbtXrRuFd6xKD4fMMeta } from "/app/pages/game/dungeon-explorer.vue?macro=true";
import { default as gameQWAwGdPwtLsmyOCjoFmd2yqaforOOa9Vsw_nqU66qYoMeta } from "/app/pages/game.vue?macro=true";
import { default as helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta } from "/app/pages/help.vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as editOmwSn13deaXfRmFU5eTPQTsyJjTKM42QVwLJd_45Zxa28Meta } from "/app/pages/news/[news]/edit.vue?macro=true";
import { default as indexYNJG_qfq1aa0VvB__457tJB0scyWM03TT2Jp7jj96h_45gcMeta } from "/app/pages/news/[news]/index.vue?macro=true";
import { default as newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta } from "/app/pages/news.vue?macro=true";
import { default as shop1_Y_ssmWg_o_nR3Bp60pPblf_qjzasBy_45DGRDWYMOL4Meta } from "/app/pages/shop.vue?macro=true";
import { default as teamSEAvYegqaP9TQYa6utWHKYo3MYTiIT9JxlO2mrUHaccMeta } from "/app/pages/team.vue?macro=true";
import { default as indexVjBxRMPTh0d_45TIglqBCJuLMPrZuvab79N9Um0vxN3ggMeta } from "/app/pages/user/index.vue?macro=true";
import { default as _91user_93iue9wFkX_4577Rm6llV6RLqX_4Hl1IX8K_45aGocOfA4KtMMeta } from "/app/pages/user/[user].vue?macro=true";
import { default as userB_7Mx8PUoGfTKlaAstJ4_45e42WqCEvDAsnN3JKvvYXM8Meta } from "/app/pages/user.vue?macro=true";
import { default as rulesoW3OsXfUxMGzTjcJPfE4v0oEYZyNpAmFSWz4Vk42uNYMeta } from "/app/pages/rules.vue?macro=true";
import { default as creatorso8etGtVYV89HM03VLmhn_ZEk9_zvcyTnpPZgW9j2QIMeta } from "/app/pages/creator.vue?macro=true";
import { default as branding5I9p5yA7B9BVVwnHPFLC9fuln0RktX_f2whh_X2k21kMeta } from "/app/pages/branding.vue?macro=true";
import { default as termsp2ZV5_pcjqG5bV0QZqMPlEXzMqQS8UomIZuzGOnFCUcMeta } from "/app/pages/legal/terms.vue?macro=true";
import { default as indexiJIkIT7Ri7OwqUuz_wugYfiFX0biabek2895yvBQ38cMeta } from "/app/pages/participate/index.vue?macro=true";
import { default as editorUYWSyVqOFzxeiWSkZupqNLRhetseyfvQxUd8FtiEtukMeta } from "/app/pages/participate/editor.vue?macro=true";
import { default as builderskSJLDnoNZca7y5M_cWK_CTKL_45jrC3_45Uq5exXDmW3hUMeta } from "/app/pages/participate/builder.vue?macro=true";
import { default as promoterR0gBRv71nxT9oZlC_iS1Xo0o1HFWut12PtG5sIhG9agMeta } from "/app/pages/participate/promoter.vue?macro=true";
import { default as supporterAvtdh0S0coSy6XUvNflthJnzZRZwAmDjlTViK4UN47oMeta } from "/app/pages/participate/supporter.vue?macro=true";
import { default as game_45designervxSbls61s9VsVwy1ipYI3Oo3Ykk2y_E1wN1JkmwR15kMeta } from "/app/pages/participate/game-designer.vue?macro=true";
import { default as web_45developer_qcpRs1l4gpJCQ2O8DLK9TIzmk0uw8zJ1zH8Oah4B10Meta } from "/app/pages/participate/web-developer.vue?macro=true";
import { default as audio_45designerraJBwRwwKdFIhJYjHnrjw1_jwxx4Zwc6rF2aSNLItUsMeta } from "/app/pages/participate/audio-designer.vue?macro=true";
import { default as game_45developeryqOJv_ZjDWfgi4_45nWU7YPR6NrVlPBD7gEWrphu76oUkMeta } from "/app/pages/participate/game-developer.vue?macro=true";
import { default as graphic_45artistu3yYFqFwxrSx_45Ecpx1P6aVTUFugIVA8VtvIjYJ3WRskMeta } from "/app/pages/participate/graphic-artist.vue?macro=true";
import { default as video_45producer_mOlsQrTFMblGok2TDOI6pl0NOO35s675jj_457E1ObssMeta } from "/app/pages/participate/video-producer.vue?macro=true";
import { default as infra_45developerLtwYkH4Qd25DGvqTrP40Zf9YE9NRaI5RAbo2STkIznMMeta } from "/app/pages/participate/infra-developer.vue?macro=true";
import { default as participate_yg0SAaWBAYGq2iLk8emRJZjuu9mCWZBqWbK8A1U_54Meta } from "/app/pages/participate.vue?macro=true";
import { default as noticewOvNrLO_45EIxYHg1qonE_45h53cixfRg9B0qww5RXP99ZcMeta } from "/app/pages/legal/notice.vue?macro=true";
import { default as privacyN_45OgLlUD_qeUb0gRxeQMuZ9Wz1vld09XF6rpynCcDnkMeta } from "/app/pages/legal/privacy.vue?macro=true";
import { default as component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQMeta } from "/app/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.26.0_jiti@2.4_7b71c36ff82434ae125e053a37f62370/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQ } from "/app/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.26.0_jiti@2.4_7b71c36ff82434ae125e053a37f62370/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: gameQWAwGdPwtLsmyOCjoFmd2yqaforOOa9Vsw_nqU66qYoMeta?.name,
    path: "/en/game",
    component: () => import("/app/pages/game.vue"),
    children: [
  {
    name: "game___en",
    path: "",
    meta: index_1yPZ9E4sXNQdvJ8urx3VX6hEo9s9Pej1Y1RhFdGfoEMeta || {},
    component: () => import("/app/pages/game/index.vue")
  },
  {
    name: clashlands0VGdx5S_45zgF8_45LGf03pwOXTNJnc7J_XVZkkVvpPCGHoMeta?.name,
    path: "clashlands",
    component: () => import("/app/pages/game/clashlands.vue"),
    children: [
  {
    name: "game-clashlands___en",
    path: "",
    meta: indexZoRl0O3HdeL6tALF_45Ty2aq8nNG9odyaCcjqrf90NbtIMeta || {},
    component: () => import("/app/pages/game/clashlands/index.vue")
  }
]
  },
  {
    name: dungeon_45explorerM2LXErIaib5qEqVvhP_45z_45wPoghMUbtXrRuFd6xKD4fMMeta?.name,
    path: "dungeon-explorer",
    component: () => import("/app/pages/game/dungeon-explorer.vue"),
    children: [
  {
    name: "game-dungeon-explorer-guide___en",
    path: "guide",
    meta: guideAHnivJoLASjtXot4S5WKe93ON1voDHlsQVig3Gwt1qwMeta || {},
    component: () => import("/app/pages/game/dungeon-explorer/guide.vue")
  },
  {
    name: "game-dungeon-explorer___en",
    path: "",
    meta: indexN5_RbRHSEF03_UoR64cFEh_45Z7qBb8pApFIHElC66_45g4Meta || {},
    component: () => import("/app/pages/game/dungeon-explorer/index.vue")
  },
  {
    name: "game-dungeon-explorer-leaderboard___en",
    path: "leaderboard",
    meta: leaderboarda544q4twEaRx9A1VOiX7FJxQC_hF7oZYxH9X5Sa2VAMMeta || {},
    component: () => import("/app/pages/game/dungeon-explorer/leaderboard.vue")
  }
]
  }
]
  },
  {
    name: gameQWAwGdPwtLsmyOCjoFmd2yqaforOOa9Vsw_nqU66qYoMeta?.name,
    path: "/de/game",
    component: () => import("/app/pages/game.vue"),
    children: [
  {
    name: "game___de",
    path: "",
    meta: index_1yPZ9E4sXNQdvJ8urx3VX6hEo9s9Pej1Y1RhFdGfoEMeta || {},
    component: () => import("/app/pages/game/index.vue")
  },
  {
    name: clashlands0VGdx5S_45zgF8_45LGf03pwOXTNJnc7J_XVZkkVvpPCGHoMeta?.name,
    path: "clashlands",
    component: () => import("/app/pages/game/clashlands.vue"),
    children: [
  {
    name: "game-clashlands___de",
    path: "",
    meta: indexZoRl0O3HdeL6tALF_45Ty2aq8nNG9odyaCcjqrf90NbtIMeta || {},
    component: () => import("/app/pages/game/clashlands/index.vue")
  }
]
  },
  {
    name: dungeon_45explorerM2LXErIaib5qEqVvhP_45z_45wPoghMUbtXrRuFd6xKD4fMMeta?.name,
    path: "dungeon-explorer",
    component: () => import("/app/pages/game/dungeon-explorer.vue"),
    children: [
  {
    name: "game-dungeon-explorer-guide___de",
    path: "guide",
    meta: guideAHnivJoLASjtXot4S5WKe93ON1voDHlsQVig3Gwt1qwMeta || {},
    component: () => import("/app/pages/game/dungeon-explorer/guide.vue")
  },
  {
    name: "game-dungeon-explorer___de",
    path: "",
    meta: indexN5_RbRHSEF03_UoR64cFEh_45Z7qBb8pApFIHElC66_45g4Meta || {},
    component: () => import("/app/pages/game/dungeon-explorer/index.vue")
  },
  {
    name: "game-dungeon-explorer-leaderboard___de",
    path: "leaderboard",
    meta: leaderboarda544q4twEaRx9A1VOiX7FJxQC_hF7oZYxH9X5Sa2VAMMeta || {},
    component: () => import("/app/pages/game/dungeon-explorer/leaderboard.vue")
  }
]
  }
]
  },
  {
    name: "help___en",
    path: "/en/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___de",
    path: "/de/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta?.name,
    path: "/en/news",
    component: () => import("/app/pages/news.vue"),
    children: [
  {
    name: "news___en",
    path: "",
    meta: indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta || {},
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news-news-edit___en",
    path: ":news()/edit",
    meta: { ...(editOmwSn13deaXfRmFU5eTPQTsyJjTKM42QVwLJd_45Zxa28Meta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/app/pages/news/[news]/edit.vue")
  },
  {
    name: "news-news___en",
    path: ":news()",
    meta: indexYNJG_qfq1aa0VvB__457tJB0scyWM03TT2Jp7jj96h_45gcMeta || {},
    component: () => import("/app/pages/news/[news]/index.vue")
  }
]
  },
  {
    name: newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta?.name,
    path: "/de/news",
    component: () => import("/app/pages/news.vue"),
    children: [
  {
    name: "news___de",
    path: "",
    meta: indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta || {},
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news-news-edit___de",
    path: ":news()/edit",
    meta: { ...(editOmwSn13deaXfRmFU5eTPQTsyJjTKM42QVwLJd_45Zxa28Meta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/app/pages/news/[news]/edit.vue")
  },
  {
    name: "news-news___de",
    path: ":news()",
    meta: indexYNJG_qfq1aa0VvB__457tJB0scyWM03TT2Jp7jj96h_45gcMeta || {},
    component: () => import("/app/pages/news/[news]/index.vue")
  }
]
  },
  {
    name: "shop___en",
    path: "/en/shop",
    meta: shop1_Y_ssmWg_o_nR3Bp60pPblf_qjzasBy_45DGRDWYMOL4Meta || {},
    component: () => import("/app/pages/shop.vue")
  },
  {
    name: "shop___de",
    path: "/de/shop",
    meta: shop1_Y_ssmWg_o_nR3Bp60pPblf_qjzasBy_45DGRDWYMOL4Meta || {},
    component: () => import("/app/pages/shop.vue")
  },
  {
    name: "team___en",
    path: "/en/team",
    meta: teamSEAvYegqaP9TQYa6utWHKYo3MYTiIT9JxlO2mrUHaccMeta || {},
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "team___de",
    path: "/de/team",
    meta: teamSEAvYegqaP9TQYa6utWHKYo3MYTiIT9JxlO2mrUHaccMeta || {},
    component: () => import("/app/pages/team.vue")
  },
  {
    name: userB_7Mx8PUoGfTKlaAstJ4_45e42WqCEvDAsnN3JKvvYXM8Meta?.name,
    path: "/en/user",
    component: () => import("/app/pages/user.vue"),
    children: [
  {
    name: "user___en",
    path: "",
    component: () => import("/app/pages/user/index.vue")
  },
  {
    name: "user-user___en",
    path: ":user()",
    meta: _91user_93iue9wFkX_4577Rm6llV6RLqX_4Hl1IX8K_45aGocOfA4KtMMeta || {},
    component: () => import("/app/pages/user/[user].vue")
  }
]
  },
  {
    name: userB_7Mx8PUoGfTKlaAstJ4_45e42WqCEvDAsnN3JKvvYXM8Meta?.name,
    path: "/de/user",
    component: () => import("/app/pages/user.vue"),
    children: [
  {
    name: "user___de",
    path: "",
    component: () => import("/app/pages/user/index.vue")
  },
  {
    name: "user-user___de",
    path: ":user()",
    meta: _91user_93iue9wFkX_4577Rm6llV6RLqX_4Hl1IX8K_45aGocOfA4KtMMeta || {},
    component: () => import("/app/pages/user/[user].vue")
  }
]
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "rules___en",
    path: "/en/rules",
    meta: rulesoW3OsXfUxMGzTjcJPfE4v0oEYZyNpAmFSWz4Vk42uNYMeta || {},
    component: () => import("/app/pages/rules.vue")
  },
  {
    name: "rules___de",
    path: "/de/rules",
    meta: rulesoW3OsXfUxMGzTjcJPfE4v0oEYZyNpAmFSWz4Vk42uNYMeta || {},
    component: () => import("/app/pages/rules.vue")
  },
  {
    name: "creator___en",
    path: "/en/creator",
    meta: creatorso8etGtVYV89HM03VLmhn_ZEk9_zvcyTnpPZgW9j2QIMeta || {},
    component: () => import("/app/pages/creator.vue")
  },
  {
    name: "creator___de",
    path: "/de/creator",
    meta: creatorso8etGtVYV89HM03VLmhn_ZEk9_zvcyTnpPZgW9j2QIMeta || {},
    component: () => import("/app/pages/creator.vue")
  },
  {
    name: "branding___en",
    path: "/en/branding",
    meta: branding5I9p5yA7B9BVVwnHPFLC9fuln0RktX_f2whh_X2k21kMeta || {},
    component: () => import("/app/pages/branding.vue")
  },
  {
    name: "branding___de",
    path: "/de/branding",
    meta: branding5I9p5yA7B9BVVwnHPFLC9fuln0RktX_f2whh_X2k21kMeta || {},
    component: () => import("/app/pages/branding.vue")
  },
  {
    name: "legal-terms___en",
    path: "/en/legal/terms",
    meta: termsp2ZV5_pcjqG5bV0QZqMPlEXzMqQS8UomIZuzGOnFCUcMeta || {},
    component: () => import("/app/pages/legal/terms.vue")
  },
  {
    name: "legal-terms___de",
    path: "/de/legal/terms",
    meta: termsp2ZV5_pcjqG5bV0QZqMPlEXzMqQS8UomIZuzGOnFCUcMeta || {},
    component: () => import("/app/pages/legal/terms.vue")
  },
  {
    name: participate_yg0SAaWBAYGq2iLk8emRJZjuu9mCWZBqWbK8A1U_54Meta?.name,
    path: "/en/participate",
    component: () => import("/app/pages/participate.vue"),
    children: [
  {
    name: "participate___en",
    path: "",
    meta: indexiJIkIT7Ri7OwqUuz_wugYfiFX0biabek2895yvBQ38cMeta || {},
    component: () => import("/app/pages/participate/index.vue")
  },
  {
    name: "participate-editor___en",
    path: "editor",
    meta: editorUYWSyVqOFzxeiWSkZupqNLRhetseyfvQxUd8FtiEtukMeta || {},
    component: () => import("/app/pages/participate/editor.vue")
  },
  {
    name: "participate-builder___en",
    path: "builder",
    meta: builderskSJLDnoNZca7y5M_cWK_CTKL_45jrC3_45Uq5exXDmW3hUMeta || {},
    component: () => import("/app/pages/participate/builder.vue")
  },
  {
    name: "participate-promoter___en",
    path: "promoter",
    meta: promoterR0gBRv71nxT9oZlC_iS1Xo0o1HFWut12PtG5sIhG9agMeta || {},
    component: () => import("/app/pages/participate/promoter.vue")
  },
  {
    name: "participate-supporter___en",
    path: "supporter",
    meta: supporterAvtdh0S0coSy6XUvNflthJnzZRZwAmDjlTViK4UN47oMeta || {},
    component: () => import("/app/pages/participate/supporter.vue")
  },
  {
    name: "participate-game-designer___en",
    path: "game-designer",
    meta: game_45designervxSbls61s9VsVwy1ipYI3Oo3Ykk2y_E1wN1JkmwR15kMeta || {},
    component: () => import("/app/pages/participate/game-designer.vue")
  },
  {
    name: "participate-web-developer___en",
    path: "web-developer",
    meta: web_45developer_qcpRs1l4gpJCQ2O8DLK9TIzmk0uw8zJ1zH8Oah4B10Meta || {},
    component: () => import("/app/pages/participate/web-developer.vue")
  },
  {
    name: "participate-audio-designer___en",
    path: "audio-designer",
    meta: audio_45designerraJBwRwwKdFIhJYjHnrjw1_jwxx4Zwc6rF2aSNLItUsMeta || {},
    component: () => import("/app/pages/participate/audio-designer.vue")
  },
  {
    name: "participate-game-developer___en",
    path: "game-developer",
    meta: game_45developeryqOJv_ZjDWfgi4_45nWU7YPR6NrVlPBD7gEWrphu76oUkMeta || {},
    component: () => import("/app/pages/participate/game-developer.vue")
  },
  {
    name: "participate-graphic-artist___en",
    path: "graphic-artist",
    meta: graphic_45artistu3yYFqFwxrSx_45Ecpx1P6aVTUFugIVA8VtvIjYJ3WRskMeta || {},
    component: () => import("/app/pages/participate/graphic-artist.vue")
  },
  {
    name: "participate-video-producer___en",
    path: "video-producer",
    meta: video_45producer_mOlsQrTFMblGok2TDOI6pl0NOO35s675jj_457E1ObssMeta || {},
    component: () => import("/app/pages/participate/video-producer.vue")
  },
  {
    name: "participate-infra-developer___en",
    path: "infra-developer",
    meta: infra_45developerLtwYkH4Qd25DGvqTrP40Zf9YE9NRaI5RAbo2STkIznMMeta || {},
    component: () => import("/app/pages/participate/infra-developer.vue")
  }
]
  },
  {
    name: participate_yg0SAaWBAYGq2iLk8emRJZjuu9mCWZBqWbK8A1U_54Meta?.name,
    path: "/de/participate",
    component: () => import("/app/pages/participate.vue"),
    children: [
  {
    name: "participate___de",
    path: "",
    meta: indexiJIkIT7Ri7OwqUuz_wugYfiFX0biabek2895yvBQ38cMeta || {},
    component: () => import("/app/pages/participate/index.vue")
  },
  {
    name: "participate-editor___de",
    path: "editor",
    meta: editorUYWSyVqOFzxeiWSkZupqNLRhetseyfvQxUd8FtiEtukMeta || {},
    component: () => import("/app/pages/participate/editor.vue")
  },
  {
    name: "participate-builder___de",
    path: "builder",
    meta: builderskSJLDnoNZca7y5M_cWK_CTKL_45jrC3_45Uq5exXDmW3hUMeta || {},
    component: () => import("/app/pages/participate/builder.vue")
  },
  {
    name: "participate-promoter___de",
    path: "promoter",
    meta: promoterR0gBRv71nxT9oZlC_iS1Xo0o1HFWut12PtG5sIhG9agMeta || {},
    component: () => import("/app/pages/participate/promoter.vue")
  },
  {
    name: "participate-supporter___de",
    path: "supporter",
    meta: supporterAvtdh0S0coSy6XUvNflthJnzZRZwAmDjlTViK4UN47oMeta || {},
    component: () => import("/app/pages/participate/supporter.vue")
  },
  {
    name: "participate-game-designer___de",
    path: "game-designer",
    meta: game_45designervxSbls61s9VsVwy1ipYI3Oo3Ykk2y_E1wN1JkmwR15kMeta || {},
    component: () => import("/app/pages/participate/game-designer.vue")
  },
  {
    name: "participate-web-developer___de",
    path: "web-developer",
    meta: web_45developer_qcpRs1l4gpJCQ2O8DLK9TIzmk0uw8zJ1zH8Oah4B10Meta || {},
    component: () => import("/app/pages/participate/web-developer.vue")
  },
  {
    name: "participate-audio-designer___de",
    path: "audio-designer",
    meta: audio_45designerraJBwRwwKdFIhJYjHnrjw1_jwxx4Zwc6rF2aSNLItUsMeta || {},
    component: () => import("/app/pages/participate/audio-designer.vue")
  },
  {
    name: "participate-game-developer___de",
    path: "game-developer",
    meta: game_45developeryqOJv_ZjDWfgi4_45nWU7YPR6NrVlPBD7gEWrphu76oUkMeta || {},
    component: () => import("/app/pages/participate/game-developer.vue")
  },
  {
    name: "participate-graphic-artist___de",
    path: "graphic-artist",
    meta: graphic_45artistu3yYFqFwxrSx_45Ecpx1P6aVTUFugIVA8VtvIjYJ3WRskMeta || {},
    component: () => import("/app/pages/participate/graphic-artist.vue")
  },
  {
    name: "participate-video-producer___de",
    path: "video-producer",
    meta: video_45producer_mOlsQrTFMblGok2TDOI6pl0NOO35s675jj_457E1ObssMeta || {},
    component: () => import("/app/pages/participate/video-producer.vue")
  },
  {
    name: "participate-infra-developer___de",
    path: "infra-developer",
    meta: infra_45developerLtwYkH4Qd25DGvqTrP40Zf9YE9NRaI5RAbo2STkIznMMeta || {},
    component: () => import("/app/pages/participate/infra-developer.vue")
  }
]
  },
  {
    name: "legal-notice___en",
    path: "/en/legal/notice",
    meta: noticewOvNrLO_45EIxYHg1qonE_45h53cixfRg9B0qww5RXP99ZcMeta || {},
    component: () => import("/app/pages/legal/notice.vue")
  },
  {
    name: "legal-notice___de",
    path: "/de/legal/notice",
    meta: noticewOvNrLO_45EIxYHg1qonE_45h53cixfRg9B0qww5RXP99ZcMeta || {},
    component: () => import("/app/pages/legal/notice.vue")
  },
  {
    name: "legal-privacy___en",
    path: "/en/legal/privacy",
    meta: privacyN_45OgLlUD_qeUb0gRxeQMuZ9Wz1vld09XF6rpynCcDnkMeta || {},
    component: () => import("/app/pages/legal/privacy.vue")
  },
  {
    name: "legal-privacy___de",
    path: "/de/legal/privacy",
    meta: privacyN_45OgLlUD_qeUb0gRxeQMuZ9Wz1vld09XF6rpynCcDnkMeta || {},
    component: () => import("/app/pages/legal/privacy.vue")
  },
  {
    name: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQMeta?.name,
    path: "/en/security.txt",
    component: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQ
  },
  {
    name: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQMeta?.name,
    path: "/de/security.txt",
    component: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQ
  },
  {
    name: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQ
  },
  {
    name: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubn1PcR3oDvKd3GaFf0RagfF2ihgld5Ka8wyp3KSOIzdQ
  }
]